<script setup>
import { inject } from 'vue'

const t = inject('t')
</script>

<template>
  <article>
    <section class="one">
      <div>
        <h3>Powered by</h3>
        <a href="https://sgb.ch" target="_blank" aria-label="SGB Website">
          <img src="@/assets/sgb.svg" alt="SGB Logo" />
        </a>
      </div>
      <span class="copy">&copy; {{ new Date().getFullYear() }}</span>
    </section>
    <section class="second">
      <div class="contact">
        <span>{{ t('telefon') }} 031 377 01 01</span>
        <span>{{ t('sgb-email') }}</span>
        <span>
          <RouterLink :to="{ name: 'flat-page', params: { slug: 'impressum' } }">{{
            t('impressum')
          }}</RouterLink>
        </span>
        <span>
          <RouterLink :to="{ name: 'flat-page', params: { slug: 'privacy' } }">{{
            t('privacy')
          }}</RouterLink>
        </span>
      </div>
      <div class="some">
        <a :href="t('facebook-url')" target="_blank" aria-label="SGB Facebook">
          <img src="@/assets/some/facebook.svg" alt="facebook" />
        </a>
        <a :href="t('instagram-url')" target="_blank" aria-label="SGB Instagram">
          <img src="@/assets/some/insta.svg" alt="instagram" />
        </a>
        <a :href="t('linkedin-url')" target="_blank" aria-label="SGB LinkedIn">
          <img src="@/assets/some/linkedin.svg" alt="linkedin" />
        </a>
      </div>
    </section>
    <section class="membership">
      <h3>{{ t('mitglied-titel') }}</h3>
      <p>
        {{ t('mitglied-text') }}
      </p>
      <a class="btn" :href="t('mitglied-url')" target="_blank">{{ t('mitglied-button') }}</a>
    </section>
  </article>
</template>

<style scoped>
article {
  display: flex;
  padding-top: 130px;
  padding-bottom: 40px;
  gap: 1em;
  flex-wrap: wrap-reverse;
}

article a {
  color: var(--color-text);
  text-decoration: none;
}

article section {
  flex: 1;
  min-width: 10em;
}

h3 {
  margin: 0;
  font-size: var(--font-size);
}

section.one h3 {
  margin-bottom: 1em;
  font-weight: 400;
}

div.some {
  margin-top: 3em;
  margin-bottom: 3em;
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  max-width: 200px;
}

div.some svg {
  width: 42px;
  height: 42px;
}

article section.one {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

section.one .copy {
  margin-top: 2em;
  flex: 0;
}

section.second .contact {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  font-weight: lighter;
  gap: 5px;
}

section.membership {
  color: var(--color-signal);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 2em;
}

section.membership p {
  margin-top: 0.8rem;
  margin-bottom: 1.5rem;
}

.btn {
  background-color: var(--color-signal);
  padding: 14px 20px;
  border-radius: 38px;
  color: white;
  text-decoration: none;
}
</style>
